import styled from 'styled-components';

export const ThemeSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;
